import React, { FC } from 'react';
import styled, { css } from 'styled-components';

import ApiToken from 'src/models/Integrations/apiToken';
import RemoveFillIcon from '@ad-scripts/presentation/components/common/icons/fill/remove-fill';
import apiTokensResource from 'src/actions/integrations/apiTokensResource';
import { Delete } from 'src/presentation/components/pages/shared/rowActions/Delete';

type RowActionProps = {
  item: ApiToken;
};

const RowActions: FC<RowActionProps> = ({ item }) => {
  const handleOpenDeleteModal = callbackOpenModal => {
    callbackOpenModal();
  };

  return (
    <Delete
      confirmationText="Delete API token"
      deleteAction={apiTokensResource.effects.remove}
      deleteIcon={StyledTrashIcon}
      description={`Are you sure you want to delete ${item.name}?`}
      handleOpenModal={handleOpenDeleteModal}
      id={item.id}
      submitText="Delete API token"
    />
  );
};

const iconFillStyles = css`
  fill: ${p => p.theme.colors.gray600};
`;
const StyledTrashIcon = styled(RemoveFillIcon)`
  ${iconFillStyles}
`;

export default RowActions;
